import { useContext, useEffect } from 'react';
import { useState } from 'react';
import Colors from '../../../constants/Colors';
import bookingOauthRequest from '../../../utils/networking/oauth/booking.com/oauthBooking.service.js';
import constants from '../../../utils/constants';
import { notification } from 'antd';
import { useLocation } from 'react-router-dom';
import { AppContext } from '../../../App.context';
import apiConfig from '../../../utils/networking/api.config';
import { ApiContext } from '../../../utils/networking/Api.context';
import { useNavigate } from 'react-router-dom';

export default function useSalesChannelsHook() {
  const {
    appState,
    appActions: { translate, setSelectedHotel, getSelectedHotel },
  } = useContext(AppContext);
  const navigate = useNavigate();

  const { API } = useContext(ApiContext);
  const location = useLocation();

  const [state, setState] = useState({
    isLoading: true,
    dataSource: {
      items: [],
      totalItems: 0,
      totalPages: 0,
      currentPage: 0,
      pageSize: 10,
    },
    filters: {},
    identifiers: {},
    identifierError: {},
    showOTAPopup: false,
    ota: location?.state?.ota || null,
    hotelSlug: location?.state?.hotelSlug || null,
    showMultiPropertyConfig: false,
    paperlessAccountHotels: [],
    paperlessUserSelectedHotel: null,
    selectedPaperlessUser: null,
    HBXAggregatorActiveChannels: [],
    activeChannelId: null,
    activeChannelFields: {},
    showHBXChannelForm: false,
    selectorOptions: [],
  });

  var activeRequests = 0;

  useEffect(() => {
    if (appState.hotelList) {
      if (location?.state?.ota && location?.state?.hotelSlug) {
        var selectedHotel = appState.hotelList.find(
          hotel => hotel.slug == location?.state?.hotelSlug
        );
        const firstHotel = {
          key: selectedHotel.id,
          value: selectedHotel.name,
        };
        setSelectedHotel(firstHotel);
        updateState({ showOTAPopup: true });
      }
    }
  }, [appState.hotelList]);

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const callback = params.get('callback');
    if (callback) {
      switch (callback) {
        case constants.STRIPE.BOOKING_SUCCESS:
          actions.connectBooking(params.get('hotelId'), params.get('hotelFilter'));
          break;
        case constants.BOOKINGDOTCOM.REDIRECT_PATH:
          actions.authBooking(params.get('code'), params.get('hotelId'), params.get('hotelFilter'));
          break;
        default:
          actions.loadSalesChannels();
          break;
      }
    } else {
      actions.loadSalesChannels();
    }
  }, [state.dataSource.currentPage, state.filters, appState.selectedHotel]);

  useEffect(() => {
    async function getHBXCheckinChannelsConfig() {
      // Get select field options
      const selectOptions = await API.getSelectOptions();

      // Get active channel for current hotel
      const hotelId = getSelectedHotel()?.id;
      const channel = await API.getHBXChannelHotelActive(hotelId);

      // Get Check-in channels
      const channels = await API.getHBXAggregatorChannels();
      updateState({
        HBXAggregatorActiveChannels: channels.filter(chan =>
          channel?.channel_id ? channel?.channel_id === chan.id : chan.active
        ),
        selectorOptions: selectOptions,
      });

      // Get channel fields to create config form
      const channelFields = await API.getHBXChannelHotelFields(hotelId, channel?.channel_id);
      updateState({ activeChannelId: channel?.channel_id, activeChannelFields: channelFields });
    }

    getHBXCheckinChannelsConfig();
  }, []);

  const actions = {
    loadSalesChannels: () => {
      activeRequests = activeRequests++;
      updateState({ isLoading: true });

      API.salesChannelsRequest(
        state.dataSource?.currentPage,
        state.dataSource?.pageSize,
        state.filters,
        state.sort,
        getSelectedHotel()
      )
        .then(data => {
          activeRequests = activeRequests--;
          const parsedChannels = [];
          data.items.forEach(item => {
            item.clients.forEach(client => {
              const row = {
                id: client.id,
                hotelId: item.id,
                atlasId: item.atlas_id,
                hotel: item.name,
                hotelSlug: item.slug,
                client: client,
                premium: item.premium,
                smtpCredentials: item.smtpCredentials,
              };

              if (client.client_id === 23 || client.client_id === 24) {
                // no-op
              } else if (client?.enabled || client?.suscribed) {
                parsedChannels.unshift(row);
              } else if (client.name === 'MTS' && !client.exists) {
                // no-op
              } else {
                parsedChannels.push(row);
              }
            });
          });
          data.items = parsedChannels;

          let otaHotelItem;
          if (location?.state?.ota && location?.state?.hotelSlug) {
            otaHotelItem = data.items.find(item => item.hotelSlug == location?.state?.hotelSlug);
          }

          updateState({ dataSource: data, isLoading: false, otaHotelItem });
        })
        .catch(error => {
          console.warn(error);
          if (activeRequests == 1) {
            updateState({ isLoading: false });
          }
          activeRequests--;
        });
    },

    onChange: filters => {
      var newPage,
        newPageSize = -1;
      var searchFilters;
      if (state.dataSource?.currentPage !== filters?.pagination.page) {
        newPage = filters?.pagination.page;
      }
      if (state.dataSource?.pageSize !== filters?.pagination.pageSize) {
        newPageSize = filters?.pagination.pageSize;
      }
      if (filters?.where) {
        const hotel = filters?.where['hotel'];
        const channel = filters?.where['client.name'];
        searchFilters = { hotel, channel };
      }

      updateState({
        dataSource: {
          ...state.dataSource,
          currentPage: newPage >= 0 ? newPage : state.dataSource?.currentPage,
          pageSize: newPageSize >= 0 ? newPageSize : state.dataSource?.pageSize,
        },
        filters: searchFilters,
      });
    },

    getClientStateString: client => {
      if (client.client_id === constants.IH_CLIENT.BOOKINGDOTCOM) {
        if (
          state.dataSource.items.some(
            item => item.smtpCredentials && Object.keys(item.smtpCredentials).length > 0
          )
        ) {
          return translate('states.enabled');
        }
      }

      if (client.enabled) {
        return translate('states.enabled');
      } else if (client.suscribed) {
        return translate('states.pending');
      } else {
        return translate('states.disabled');
      }
    },

    getClientStateTextColor: client => {
      if (client.client_id === constants.IH_CLIENT.BOOKINGDOTCOM) {
        if (
          state.dataSource.items.some(
            item => item.smtpCredentials && Object.keys(item.smtpCredentials).length > 0
          )
        ) {
          return Colors.greenHotelIntegratedText;
        }
      }

      if (client.enabled) {
        return Colors.greenHotelIntegratedText;
      } else if (client.suscribed) {
        return Colors.yellowHotelNoIntegratedText;
      } else {
        return Colors.redDesactivedText;
      }
    },

    getClientStateBackgroundColor: client => {
      if (client.client_id === constants.IH_CLIENT.BOOKINGDOTCOM) {
        if (
          state.dataSource.items.some(
            item => item.smtpCredentials && Object.keys(item.smtpCredentials).length > 0
          )
        ) {
          return Colors.greenHotelIntegratedBg;
        }
      }

      if (client.enabled) {
        return Colors.greenHotelIntegratedBg;
      } else if (client.suscribed) {
        return Colors.yellowHotelNoIntegratedBg;
      } else {
        return Colors.redDesactivedBg;
      }
    },

    getIdentifier: channel => {
      const valuesForHotel = state.identifiers[channel?.hotelId];
      return valuesForHotel
        ? valuesForHotel[channel?.client.client_id]
        : channel?.client?.custom_hotel_id;
    },

    setIdentifier: (hotelId, channelId, value) => {
      const values = state.identifiers;
      if (values[hotelId]) {
        values[hotelId][channelId] = value;
      } else {
        values[hotelId] = [];
        values[hotelId][channelId] = value;
      }

      updateState({ identifiers: values, identifierError: {} });
    },

    onConfigureChannelPressed: channel => {
      const customIdentifier = actions.getIdentifier(channel);
      switch (channel.client.client_id) {
        case constants.IH_CLIENT.BOOKINGDOTCOM:
          if (customIdentifier) {
            actions.startStripeSuscription(
              channel.hotelId,
              channel?.client?.client_id,
              customIdentifier,
              channel.hotel
            );
          } else {
            actions.setInputIdentifierAsError(channel.hotelId, channel.client.client_id);
          }
          break;
        default:
          notification.warning({ message: 'Canal de venta no implementado!' });
          break;
      }
    },

    startStripeSuscription: (hotelId, clientId, customHotelId, filter) => {
      const { host } = apiConfig;

      document.getElementById('hotelId').value = hotelId;
      document.getElementById('clientId').value = clientId;
      document.getElementById('customHotelId').value = customHotelId;
      document.getElementById('hotelFilter').value = filter;
      document.getElementById('type').value = constants.SUSCRIPTION_TYPE.IH_CLIENT;
      const stripePayment = document.getElementById('StripeBookingPayment');
      stripePayment.action = `${host}stripe/create-checkout-session`;
      stripePayment.submit();
    },

    /* connectBooking: channel => {
      const customIdentifier = actions.getIdentifier(channel);
      if (customIdentifier) {
        // TODO
        
         * Booking.com doesn't require a Stripe suscription in order to be connected till end of august.
           It will be treated as a premium suscription.
        

        actions.createPremiumSuscription(
          channel.hotelId,
          channel?.client?.client_id,
          customIdentifier
        );

        /* if (channel.premium) {
          actions.createPremiumSuscription(
            channel.hotelId,
            channel?.client?.client_id,
            customIdentifier
          );
        } else {
          actions.redirectToBookingAuth(channel.hotelId, channel.hotelFilter);
        } 
      } else {
        actions.setInputIdentifierAsError(channel.hotelId, channel.client.client_id);
      }
    },

    authBooking: (code, hotelId, hotelFilter) => {
      bookingOauthRequest(code, hotelId)
        .then(data => {
          window.location.replace(`${constants.DOMAIN_URL}/channels`);
        })
        .catch(error => {
          window.location.replace(`${constants.DOMAIN_URL}/channels`);
        });
    },

    redirectToBookingAuth: (hotelId, hotelFilter) => {
      window.location.replace(
        `${constants.BOOKINGDOTCOM.OAUTH_URL}?response_type=code&client_id=${constants.BOOKINGDOTCOM.CLIENT_ID}&redirect_uri=${constants.DOMAIN_URL}/booking-oauth?hotelId=${hotelId}&hotelFilter=${hotelFilter}`
      );

      // TEST Booking.com in local
      // window.location.replace(
      //   'http://localhost:3000/booking-oauth?hotelId=757&code=JTkq1FP1mCV7MmxLDtW9h6SMqcCTjZ624L44LAJhu2t'
      // );
    },*/

    shouldShowInputIdentifierAsError: (hotelId, channelId) => {
      return state.identifierError[hotelId] == [channelId];
    },

    setInputIdentifierAsError: (hotelId, channelId) => {
      const error = {};
      error[hotelId] = channelId;

      updateState({ identifierError: error });
    },

    handlePopoverVisibility: () => {
      updateState({ identifierError: {} });
    },

    createPremiumSuscription: (hotelId, clientId, customIdentifier) => {
      API.createPremiumSuscription({
        hotelId,
        clientId,
        customIdentifier,
        type: constants.SUSCRIPTION_TYPE.IH_CLIENT,
      })
        .then(data => {
          // actions.redirectToBookingAuth(hotelId);
        })
        .catch(err => console.error(err));
    },

    changeOTAState: channel => {
      const enabled = channel.client.enabled ? 0 : 1;
      API.updateSalesChannelRequest(channel.client.id, enabled, channel.id)
        .then(() => {
          notification.success({
            message: translate('salesChannels.success'),
          });
          actions.loadSalesChannels();
        })
        .catch(error => console.error(error));
    },

    ctaChangeOTAState: () => {
      actions.setShowOTAPopup(false);
      actions.changeOTAState(state.otaHotelItem);
    },

    setShowOTAPopup: value => {
      updateState({ showOTAPopup: value });
    },

    addPaperlessUser: (hotelSlug, IH_CLIENT_ID) => {
      navigate(
        `/register-paperless?hotel_slug=${encodeURIComponent(
          hotelSlug
        )}&ih_client=${encodeURIComponent(IH_CLIENT_ID)}`
      );
    },
    autoAddPaperelessUserReceptionType: row => {
      updateState({ loading: true });
      API.autoCreatePaperlessUser(row.hotelId)
        .then(res => {
          updateState({ loading: false });
          actions.loadSalesChannels();
        })
        .catch(err => {
          updateState({ loading: false });
        });
    },

    onMultiPropertyConfigClicked: () => {
      actions.setShowMultiProperty(true);
    },
    setShowMultiProperty: show => {
      updateState({ showMultiPropertyConfig: show });
    },
    onSelectNewHotel: value => {
      const currentHotels = state.paperlessAccountHotels || [];

      if (value === 'all') {
        updateState({ paperlessAccountHotels: ['all'] });
        return;
      }

      if (currentHotels.includes('all')) {
        const updated = [value];

        if (value !== state.paperlessUserSelectedHotel) {
          updated.push(state.paperlessUserSelectedHotel);
        }

        updateState({ paperlessAccountHotels: updated });
        return;
      }

      const updatedHotels = Array.from(
        new Set([...currentHotels, value, state.paperlessUserSelectedHotel])
      );

      updateState({ paperlessAccountHotels: updatedHotels });
    },

    onDeselectNewHotel: value => {
      if (value === state.paperlessUserSelectedHotel) return;

      if (value === 'all') {
        const current = state.paperlessAccountHotels || [];

        if (!current.includes(state.paperlessUserSelectedHotel)) {
          updateState({
            paperlessAccountHotels: [state.paperlessUserSelectedHotel],
          });
        }

        return;
      }

      updateState({
        paperlessAccountHotels: state.paperlessAccountHotels.filter(h => h !== value),
      });
    },
    onClearNewHotel: () => {
      updateState({ paperlessAccountHotels: [state.paperlessUserSelectedHotel] });
    },

    getSelectedPaperlessAccountHotels: row => {
      if (!row.hotelId) return;

      const email = row?.client?.custom_hotel_id;
      if (!email) return;

      updateState({
        paperlessAccountHotels: [],
        paperlessUserSelectedHotel: row.hotelId,
        selectedPaperlessUser: email,
      });

      API.getPaperlessUserHotels(email)
        .then(hotelIds => {
          const allHotelIds = appState.hotelList.map(h => h.id);
          const matchedHotels = appState.hotelList.filter(hotel => hotelIds.includes(hotel.id));
          const matchedHotelIds = matchedHotels.map(h => h.id);

          if (!matchedHotelIds.includes(row.hotelId)) {
            matchedHotelIds.push(row.hotelId);
          }

          const allSelected =
            matchedHotelIds.length === allHotelIds.length &&
            matchedHotelIds.every(id => allHotelIds.includes(id));

          updateState({
            paperlessAccountHotels: allSelected ? ['all'] : matchedHotelIds,
            paperlessUserSelectedHotel: row.hotelId,
          });

          actions.onMultiPropertyConfigClicked();
        })
        .catch(error => {});
    },

    onSavePaperlessUserHotels: () => {
      updateState({ isLoading: true });
      API.updatePaperlessUserHotels(state.paperlessAccountHotels, state.selectedPaperlessUser)
        .then(response => {
          notification.success({
            message: translate('salesChannels.paperlessUserHotelConfig.success'),
          });
          updateState({ isLoading: false, showMultiPropertyConfig: false });
        })
        .catch(error => {
          notification.error({
            message: translate('salesChannels.paperlessUserHotelConfig.error'),
          });
          updateState({ isLoading: false, showMultiPropertyConfig: false });
        });
    },

    hbxChannelSelectorHandler: (hotelId, channelId) => {
      if (channelId === state.activeChannelId) return;

      const fetchData = async () => {
        const channelFields = await API.getHBXChannelHotelFields(hotelId, channelId);
        updateState({ activeChannelId: channelId, activeChannelFields: channelFields });
      };

      fetchData();
    },

    showHBXChannelFormHandler: () => {
      updateState({ showHBXChannelForm: !state.showHBXChannelForm });
    },
  };
  function updateState(object) {
    setState(previousState => ({ ...previousState, ...object }));
  }

  return { state, actions };
}
